module.exports = __webpack_public_path__ + "static/anne-ackerley.447ef13c.webp";